import { render, staticRenderFns } from "./NotesDialog.vue?vue&type=template&id=1c00022f&"
import script from "./NotesDialog.vue?vue&type=script&lang=js&"
export * from "./NotesDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports